__turbopack_context__.v({
  "ShippingAddressItem": "shipping-address-module__oeIBMG__ShippingAddressItem",
});
